<template>
  <div>
    <b-row>
      <br />
      <b-col v-if="payment.tax1" cols="12">
        <b>{{ payment.tax1 }}</b> {{ payment.amount1 | currency }}
      </b-col>
      <b-col v-if="payment.tax2" cols="12">
        <b>{{ payment.tax2 }}</b> {{ payment.amount2 | currency }}
      </b-col>
      <b-col v-if="payment.tax3" cols="12">
        <b>{{ payment.tax3 }}</b> {{ payment.amount3 | currency }}
      </b-col>
    </b-row>
    <h6>Transactions</h6>
    <div>
      <b-table
        :items="payment.transactions"
        :fields="columns"
        responsive
        hover
        striped
        bordered
        small
      >
      </b-table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["payment"],
  name: "AmountBreakdown",
  data() {
    return {
      columns: [
        { key: "transactionNumber", label: "Transaction Number" },
        {
          key: "cost",
          label: "Cost",
          formatter: (amount) => this.$options.filters.currency(amount),
        },
        { key: "paymentMethod", label: "Payment Method" },
        { key: "transactionType", label: "Transaction Type" },
        { key: "accountTime", label: "Account Time" },
        { key: "description", label: "Description" },
      ],
    };
  },
};
</script>

<style></style>
